<template>
  <div>
    <div :id="chartId" style="width: 18rem; height: 15rem"></div>
  </div>
</template>

<script>
import eCharts from "echarts"
export default {
  props: {
    chartId: {
      default: 'chartId',
      type: String
    },
    chartData: {
      default: () => {},
      type: Object
    }
  },
  watch: {
    chartData(newValue) {
      this.chartData = newValue
      this.initChart()
    }
  },
  data() {
    return {
      energyChart: null,
      energyChartOpt: {}
    }
  },
  mounted() {
    this.initChart()
    window.onresize = () => {
      this.energyChart.resize()
    }
  },
  methods: {
    initChart() {
      let chartDom = document.getElementById(this.chartId);
      this.energyChart = eCharts.init(chartDom);
      this.energyChartOpt = {
        color: ['#00ffff', '#f68181', '#a797f7', '#59dd98'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          icon: "rect",
          itemHeight: 8,
          itemWidth: 18,
        },
        grid: {
          left: '10%',
          right: '5%',
          bottom: '2%',
          top: '30%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          },
          axisLabel: {
            interval: 0,//横轴信息全部显示
            // rotate: -50,// -20度角倾斜显示
          },
          splitLine: {
            lineStyle: {
              color: "rgba(104,105,123)",
              type: "dashed"
            }
          },
          data: this.chartData.xData
        },
        yAxis: {
          type: 'value',
          name: "单位：kwh",
        },
        series: [
          {
            name: '总量',
            type: 'bar',
            barWidth: 30,
            data: this.chartData.yDataA
          },
          {
            name: '高峰',
            type: 'bar',
            barWidth: 30,
            data: this.chartData.yDataB
          },
          {
            name: '平时',
            type: 'bar',
            barWidth: 30,
            data: this.chartData.yDataC
          },
          {
            name: '低谷',
            type: 'bar',
            barWidth: 30,
            data: this.chartData.yDataD
          }
        ]
      };
      this.energyChart.setOption(this.energyChartOpt);
    },
  }
}
</script>

<style lang="scss" scoped></style>